module.exports = eval("try{require('worker_threads')}catch(e){}");